import { save, setStoreState } from '@cogitate/ui-multi-utils';
import NProgress from 'nprogress';
import { toast } from 'react-toastify';
import { commonKeys, routeKeys, storeKeys } from 'ui/data/constants/keys';
import { stripPayrollProtectionRiskQualifiersUiFields } from 'ui/utilities/commercial/payrollprotection/practitionerAge';

export const onCoveragePlanSubmit = async (model) => {
  NProgress.start();
  let resp;
  try {
    stripPayrollProtectionRiskQualifiersUiFields(model);
    resp = await save(model, commonKeys.EmptyString, routeKeys.QuoteRaterModalSubmit, commonKeys.EmptyString);

    NProgress.done();
    if (resp) {
      setStoreState(storeKeys.PolicyReducer, resp);
    }
    return resp;
  } catch (error) {
    toast.error(error.message);
    NProgress.done();
    throw new Error(error);
  }
};
